import { ApiFetch } from '../../../shared/utils/fetch';
import { unwrap, type Enveloped } from '../../../shared/utils/unwrap';
import type { Dispute, Clawback } from '../types';

export const disputesApi = {
  list: async (status?: string): Promise<Dispute[]> => {
    const qs = status ? `?status=${encodeURIComponent(status)}` : '';
    const response = await ApiFetch.get<Enveloped<Dispute[]>>(`/disputes${qs}`);
    return unwrap(response);
  },

  clawbacks: async (): Promise<Clawback[]> => {
    const response = await ApiFetch.get<Enveloped<Clawback[]>>('/disputes/clawbacks');
    return unwrap(response);
  },

  /** Refund a payment by reference (full when amount omitted). */
  refund: async (reference: string, amount?: number): Promise<unknown> => {
    return ApiFetch.post(`/payments/refund/${encodeURIComponent(reference)}`, amount !== undefined ? { amount } : {});
  },
};
